<script lang="ts">
	import CopyToClipboard from './CopyToClipboard.svelte'
	import { _ } from '@repo/i18n'
	import { Action } from '@repo/ui'
	import { ClipboardDocument, ClipboardDocumentCheck } from '@steeze-ui/heroicons'

	interface Props {
		text: string
	}

	let { text }: Props = $props()
</script>

<CopyToClipboard {text}>
	{#snippet children({ copied, onCopy })}
		<Action
			name="copy-button"
			class={copied ? 'text-green-500' : ''}
			icon={copied ? ClipboardDocumentCheck : ClipboardDocument}
			iconOutline
			onclick={onCopy}
			stopPropagation
			title={copied ? $_('clipboard.copied') : $_('clipboard.copy')}
		/>
	{/snippet}
</CopyToClipboard>
